import T from "./index.es241.js";
function i(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = h(e)) || t) {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h(e, t) {
  if (e) {
    if (typeof e == "string") return c(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e, t) : void 0;
  }
}
function c(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function b(e) {
  var t = e.sheets, n = e.images;
  return '<?xml version="1.0" ?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default ContentType="application/xml" Extension="xml"/><Default ContentType="application/vnd.openxmlformats-package.relationships+xml" Extension="rels"/>' + t.map(function(o) {
    var r = o.id;
    return '<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" PartName="/xl/worksheets/sheet'.concat(r, '.xml"/>');
  }).join("") + t.map(function(o) {
    var r = o.id, a = o.images;
    return a ? '<Override ContentType="application/vnd.openxmlformats-officedocument.drawing+xml" PartName="/xl/drawings/drawing'.concat(r, '.xml"/>') : "";
  }).join("") + '<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" PartName="/xl/workbook.xml"/><Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml" PartName="/xl/sharedStrings.xml"/><Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" PartName="/xl/styles.xml"/>' + g(n).map(function(o) {
    var r = o.fileExtension, a = o.contentType;
    return '<Default Extension="'.concat(r, '" ContentType="').concat(a, '"/>');
  }).join("") + "</Types>";
}
function g(e) {
  if (!e)
    return [];
  var t = [], n = function(p) {
    var m = T(p.contentType), y = t.find(function(v) {
      return v.fileExtension === m;
    });
    y || t.push({
      fileExtension: m,
      contentType: p.contentType
    });
  };
  if (Array.isArray(e[0]))
    for (var o = i(e), r; !(r = o()).done; )
      for (var a = r.value, f = i(a), l; !(l = f()).done; ) {
        var d = l.value;
        n(d);
      }
  else
    for (var u = i(e), s; !(s = u()).done; ) {
      var x = s.value;
      n(x);
    }
  return t;
}
export {
  b as default
};
//# sourceMappingURL=index.es212.js.map
